import { CmsProduct } from '../../../types/cms_shared_types';

export enum CardContentType {
  SINGLE = 'single',
  GROUP = 'group',
}

type SingleProductContent = {
  type: CardContentType.SINGLE;
  product: CmsProduct;
};

type ProductGroupContent = {
  type: CardContentType.GROUP;
  identifier: string;
  products: CmsProduct[];
};

export type CardContent = SingleProductContent | ProductGroupContent;

export const getCardContent = (products: CmsProduct[]) => {
  const cardContent: CardContent[] = [];

  products.forEach((product) => {
    pushProduct(cardContent, product);
  });

  return cardContent;
};

const pushProduct = (cardContent: CardContent[], product: CmsProduct) => {
  if (product.productGroupIdentifier) {
    pushGroupProduct(cardContent, product, product.productGroupIdentifier);
  } else {
    pushSingleProduct(cardContent, product);
  }
};

const pushSingleProduct = (cardContent: CardContent[], product: CmsProduct) => {
  const newProduct: SingleProductContent = {
    type: CardContentType.SINGLE,
    product: product,
  };
  cardContent.push(newProduct);
};

const pushGroupProduct = (cardContent: CardContent[], product: CmsProduct, groupIdentifier: string) => {
  const index = cardContent.findIndex(
    (entry) => entry.type === CardContentType.GROUP && entry.identifier === groupIdentifier,
  );

  if (index === -1) {
    const newGroup: ProductGroupContent = {
      type: CardContentType.GROUP,
      identifier: groupIdentifier,
      products: [product],
    };

    cardContent.push(newGroup);
  } else if (cardContent[index].type === CardContentType.GROUP) {
    cardContent[index].products.push(product);
  }
};
